const ITEMS = [
    "Administration",
    "Back-Office Support",
    "Data Management",
    "Bookkeeping Assistance",
    "Correspondence",
    "Scheduling",
    "Document Handling",
    "Process Organisation",
];

const Row = ({ items, hidden = false }) => (
    <div aria-hidden={hidden} className="flex shrink-0 items-center">
        {items.map((item) => (
            <span key={item} className="flex items-center">
                <span className="whitespace-nowrap px-8 font-display text-xl font-bold uppercase tracking-wide text-slate-300 sm:text-2xl">
                    {item}
                </span>
                <span className="h-2 w-2 rotate-45 bg-amber-400" />
            </span>
        ))}
    </div>
);

const Marquee = () => (
    <div
        data-testid="editorial-marquee"
        className="relative border-y border-white/5 bg-navy-800/40 py-6"
    >
        <div className="flex overflow-hidden">
            <div className="flex w-max animate-marquee">
                <Row items={ITEMS} />
                <Row items={ITEMS} hidden />
            </div>
        </div>
        <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-navy to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-navy to-transparent" />
    </div>
);

export default Marquee;
